import { createContext, useState } from "react";

export const LoginContext = createContext();

export const LoginProvider = ({ children }) => {
    const [email, setEmail] = useState(""); // Estado que armazena o email informado pelo usuário
    const [password, setPassword] = useState(""); // Estado que armazena a password informada pelo usuário

    return (
        <LoginContext.Provider value={{ email, setEmail, password, setPassword }}>
            {children}
        </LoginContext.Provider>
    );
};
